export const countArticleViews = {
  analysisType: 'count',
  eventCollection: 'kb.article.view',
  key: 'countArticleViews',
}
